<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">简历分析提示词</div>
    </div>
    <div class="nav2">
      <div class="myForm">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
          <el-tab-pane label="专业分析提示词（列表）" name="prompt_match_zy_list">
            <el-input
              type="textarea"
              :rows="30"
              placeholder="请输入专业分析提示词（列表）"
              v-model="promptData.prompt_match_zy_list">
            </el-input>
          </el-tab-pane>
          <el-tab-pane label="简历分析提示词（列表）" name="prompt_match_resume_list">
            <el-input
              type="textarea"
              :rows="30"
              placeholder="请输入简历分析提示词（列表）"
              v-model="promptData.prompt_match_resume_list">
            </el-input>
          </el-tab-pane>
          <el-tab-pane label="专业分析提示词（详情）" name="prompt_match_zy_detail">
            <el-input
              type="textarea"
              :rows="30"
              placeholder="请输入专业分析提示词（详情）"
              v-model="promptData.prompt_match_zy_detail">
            </el-input>
          </el-tab-pane>
          <el-tab-pane label="简历分析提示词（详情）" name="prompt_match_resume_detail">
            <el-input
              type="textarea"
              :rows="30"
              placeholder="请输入简历分析提示词（详情）"
              v-model="promptData.prompt_match_resume_detail">
            </el-input>
          </el-tab-pane>
        </el-tabs>
        <div class="button-container">
          <el-button style="margin-top:10px" icon="el-icon-s-promotion" size="small" type="primary" @click="submitForm">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: "prompt_match_zy_list",
      promptData: {
        prompt_match_zy_list: "",
        prompt_match_zy_detail: "",
        prompt_match_resume_list: "",
        prompt_match_resume_detail: ""
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.$api.crudselectonebyid({
        table: 'systems',
        id: 1,
        columns: 'prompt_match_zy_list,prompt_match_zy_detail,prompt_match_resume_list,prompt_match_resume_detail'
      });
      if (res.data && res.data.data) {
        const data = res.data.data;
        this.promptData.prompt_match_zy_list = data.prompt_match_zy_list || "";
        this.promptData.prompt_match_zy_detail = data.prompt_match_zy_detail || "";
        this.promptData.prompt_match_resume_list = data.prompt_match_resume_list || "";
        this.promptData.prompt_match_resume_detail = data.prompt_match_resume_detail || "";
      }
    },
    handleTabClick() {
      // 可以在这里添加tab切换的逻辑
    },
    // 提交
    async submitForm() {
      const res = await this.$api.crudupdatebyid({
        table: 'systems',
        id: 1,
        values: {
          prompt_match_zy_list: this.promptData.prompt_match_zy_list,
          prompt_match_zy_detail: this.promptData.prompt_match_zy_detail,
          prompt_match_resume_list: this.promptData.prompt_match_resume_list,
          prompt_match_resume_detail: this.promptData.prompt_match_resume_detail
        }
      });
      
      if (res.data && res.data.result == 1) {
        this.$message({
          message: res.data.msg || '保存成功',
          type: "success"
        });
        this.getData();
      } else {
        this.$message.error(res.data ? res.data.msg : '保存失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.index {}

.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;

  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
    padding-bottom: 20px;
  }
}

.nav2 {
  margin: 18px 0;
  background: #fff;
  border-radius: 6px;
  padding: 24px;

  .myForm {
    ::v-deep .el-form-item__label {
      font-size: 12px;
    }

    ::v-deep .el-form-item {
      margin-right: 30px;
      margin-bottom: 20px;
    }

    ::v-deep .el-tabs__item {
      height: 40px;
      line-height: 40px;
    }

    ::v-deep .el-tabs__content {
      padding: 20px 0;
    }
  }
}

.button-container {
  margin-top: 20px;
  text-align: center;
}
</style> 